import { render } from "./AdminViewImage.vue?vue&type=template&id=2ab818fe&scoped=true"
import script from "./AdminViewImage.vue?vue&type=script&lang=js"
export * from "./AdminViewImage.vue?vue&type=script&lang=js"

import "./AdminViewImage.vue?vue&type=style&index=0&id=2ab818fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab818fe"]])

export default __exports__